<template>
  <div>
    <Modal v-model="visible" width="500px" title="修改密码" :footer-hide="true" :mask-closable="false" class="my-modal top static">
      <loading :isShow="loading" />
      <div class="info-box">密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号</div>
      <Form ref="myForm" :model="formData" :label-width="90" class="modal-form full">
        <FormItem label="旧密码" prop="oldPassword" :rules="$units.formRule.required('请输入')">
          <Input v-model="formData.oldPassword" type="password" placeholder="请输入原密码" password />
        </FormItem>
        <FormItem label="新密码" prop="newPassword" :rules="pwdRule('newPassword')">
          <Input
            v-model="formData.newPassword"
            type="password"
            placeholder="请输入新密码"
            password
          />
        </FormItem>
        <FormItem label="确认密码" prop="confirmPassword" :rules="pwdRule('confirmPassword')">
          <Input
            v-model="formData.confirmPassword"
            type="password"
            placeholder="请输入确认密码"
            password
          />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      formData: {}
    };
  },
  methods: {
    // 确认密码校验是否一致
    pwdRule(code) {
      return [
        this.$units.formRule.required('请输入'),
        {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            const { newPassword, confirmPassword } = this.formData;
            if (code == 'confirmPassword' && newPassword != confirmPassword) {
              callback(new Error('两次密码输入不一致'));
            } else {
              callback();
            }
          }
        },
        {
          trigger: 'blur',
          pattern:
            /((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/,
          // message: '密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号'
          message: '密码不符合规则，请检查'
        }
      ];
    },
    async open() {
      this.formData = {};
      this.visible = true;
    },
    submit() {
      this.$refs.myForm.validate().then(isok => {
        if (!isok) {
          return;
        }
        if (this.loading) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (!this.verification(formData.confirmPassword)) {
          return;
        }
        const now = this.$units.formatDate(new Date(), 'yyyyMMdd');
        formData.confirmPassword = this.$units.sm4Encrypt(formData.confirmPassword, now + now);
        formData.oldPassword = this.$units.sm4Encrypt(formData.oldPassword, now + now);
        formData.newPassword = this.$units.sm4Encrypt(formData.newPassword, now + now);
        this.loading = true;
        this.$http({
          type: 'POST',
          url: '/system/users/modifyAccount',
          data: formData
        })
          .then(res => {
            this.visible = false;
            this.$notice.success('修改成功');
          })
          .finally(() => {
            window.setTimeout(() => {
              this.loading = false;
            }, 300);
          });
      });
    },
    //校验密码
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.info-box {
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  padding: 7px 15px;
  color: red;
  font-size: 12px;
  margin: 0 -30px 0;
  text-align: center;
}
</style>
